module.exports = __webpack_public_path__ + "static/img/img22.78e4226.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/126/img22.jpg
// module id = soXC
// module chunks = 0